import Cleave from "cleave.js/react";
import "./services.css";
import ServiceKey from "../../svg/services_key.jpg";
import ServiceAuto from "../../svg/services_auto.webp";
import ServiceCargo from "../../svg/services_cargo.jpeg";
import ServiceGozel from "../../svg/services_gozel.jpg";
import ServiceExpert from "../../svg/services_expert.jpg";
import ServiceCheck from "../../svg/services_check.webp";
import ServiceBuy from "../../svg/services_buy.jpg";
import ServiceControl from "../../svg/services_control.jpg";
import { useEffect, useState } from "react";

const Services = () => {
  return (
    <div className="services">
      <div className="services_elem">
        <div className="services_elem_desc">
          <span className="services_elem_desc_title">Подбор автомобиля под ключ</span>
          <div className="services_elem_desc_par">
            <span>- Экономия личного времени и денег</span>
            <span>- Сопровождение процесса покупки</span>
            <span>- Поиск автомобиля до результата по вашим параметрам</span>
            <span>- Гарантия на подобранный автомобиль</span>
          </div>
          <span className="services_elem_desc_price">От 25 000 ₽</span>
        </div>

        <div className="services_elem_img">
          <img src={ServiceKey} />
        </div>

        <div className="services_elem_recall">
          <div className="services_elem_desc_title">Оставьте заявку на подбор автомобиля!</div>
          <div className="home_phone_recall_clientInfo" style={{ marginTop: "0px" }}>
            <div className="home_phone_recall_clientInfo_inputs">
              <input placeholder="Как к Вам обращаться?" />
              <Cleave
                type="tel"
                placeholder="Телефон для связи"
                options={{
                  numericOnly: true,
                  delimiters: ["", ") ", " - ", " - "],
                  blocks: [3, 3, 3, 2, 2],
                  prefix: "+7(",
                  noImmediatePrefix: true,
                }}
              />
            </div>
            <div className="home_phone_recall_clientInfo_buttons">
              <div className="home_phone_recall_clientInfo_button">Отправить</div>
              <div className="home_phone_recall_clientInfo_agrees">
                Нажимая на кнопку, вы даете согласие на обработку персональных данных, разрешенных для передачи
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="services_elem">
        <div className="services_elem_desc">
          <span className="services_elem_desc_title">Выездная проверка легкого автомобиля</span>
          <div className="services_elem_desc_par">
            <span>- Возможность проверки авто без вашего присутствия</span>
            <span>- Оценка целесообразности покупки и рекомендации</span>
            <span>- Аргументированный торг с продавцом</span>
            <span>- Проверка авто по 100+ параметрам</span>
          </div>
          <span className="services_elem_desc_price">От 7 000 ₽</span>
        </div>

        <div className="services_elem_img">
          <img src={ServiceAuto} />
        </div>

        <div className="services_elem_recall">
          <div className="services_elem_desc_title">Закажите проверку автомобиля!</div>
          <div className="home_phone_recall_clientInfo" style={{ marginTop: "0px" }}>
            <div className="home_phone_recall_clientInfo_inputs">
              <input placeholder="Как к Вам обращаться?" />
              <Cleave
                type="tel"
                placeholder="Телефон для связи"
                options={{
                  numericOnly: true,
                  delimiters: ["", ") ", " - ", " - "],
                  blocks: [3, 3, 3, 2, 2],
                  prefix: "+7(",
                  noImmediatePrefix: true,
                }}
              />
            </div>
            <div className="home_phone_recall_clientInfo_buttons">
              <div className="home_phone_recall_clientInfo_button">Отправить</div>
              <div className="home_phone_recall_clientInfo_agrees">
                Нажимая на кнопку, вы даете согласие на обработку персональных данных, разрешенных для передачи
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="services_elem">
        <div className="services_elem_desc">
          <span className="services_elem_desc_title">Выездная проверка грузового автомобиля</span>
          <div className="services_elem_desc_par">
            <span>- Возможность проверки авто без вашего присутствия</span>
            <span>- Оценка целесообразности покупки и рекомендации</span>
            <span>- Аргументированный торг с продавцом</span>
            <span>- Проверка грузового авто и прицепов любого уровня</span>
          </div>
          <span className="services_elem_desc_price">От 12 000 ₽</span>
        </div>

        <div className="services_elem_img">
          <img src={ServiceCargo} />
        </div>

        <div className="services_elem_recall">
          <div className="services_elem_desc_title">Получите помощь эксперта прямо сейчас!</div>
          <div className="home_phone_recall_clientInfo" style={{ marginTop: "0px" }}>
            <div className="home_phone_recall_clientInfo_inputs">
              <input placeholder="Как к Вам обращаться?" />
              <Cleave
                type="tel"
                placeholder="Телефон для связи"
                options={{
                  numericOnly: true,
                  delimiters: ["", ") ", " - ", " - "],
                  blocks: [3, 3, 3, 2, 2],
                  prefix: "+7(",
                  noImmediatePrefix: true,
                }}
              />
            </div>
            <div className="home_phone_recall_clientInfo_buttons">
              <div className="home_phone_recall_clientInfo_button">Отправить</div>
              <div className="home_phone_recall_clientInfo_agrees">
                Нажимая на кнопку, вы даете согласие на обработку персональных данных, разрешенных для передачи
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="services_elem">
        <div className="services_elem_desc">
          <span className="services_elem_desc_title">Выездная проверка легкого коммерческого транспорта</span>
          <div className="services_elem_desc_par">
            <span>- Возможность проверки авто без вашего присутствия</span>
            <span>- Оценка целесообразности покупки и рекомендации</span>
            <span>- Аргументированный торг с продавцом</span>
            <span>- Проверка авто по 100+ параметрам</span>
          </div>
          <span className="services_elem_desc_price">От 9 000 ₽</span>
        </div>

        <div className="services_elem_img">
          <img src={ServiceGozel} />
        </div>

        <div className="services_elem_recall">
          <div className="services_elem_desc_title">Оставьте заявку - мы все подробно расскажем!</div>
          <div className="home_phone_recall_clientInfo" style={{ marginTop: "0px" }}>
            <div className="home_phone_recall_clientInfo_inputs">
              <input placeholder="Как к Вам обращаться?" />
              <Cleave
                type="tel"
                placeholder="Телефон для связи"
                options={{
                  numericOnly: true,
                  delimiters: ["", ") ", " - ", " - "],
                  blocks: [3, 3, 3, 2, 2],
                  prefix: "+7(",
                  noImmediatePrefix: true,
                }}
              />
            </div>
            <div className="home_phone_recall_clientInfo_buttons">
              <div className="home_phone_recall_clientInfo_button">Отправить</div>
              <div className="home_phone_recall_clientInfo_agrees">
                Нажимая на кнопку, вы даете согласие на обработку персональных данных, разрешенных для передачи
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="services_elem">
        <div className="services_elem_desc">
          <span className="services_elem_desc_title">Эксперт на день</span>
          <div className="services_elem_desc_par">
            <span>- Советы по выбору объявлений</span>
            <span>- Перемещение на автомобиле эксперта</span>
            <span>- Выгоднее, чем при разовом осмотре</span>
            <span>- Неограниченное количество авто в течение дня</span>
          </div>
          <span className="services_elem_desc_price">От 25 000 ₽</span>
        </div>

        <div className="services_elem_img">
          <img src={ServiceExpert} />
        </div>

        <div className="services_elem_recall">
          <div className="services_elem_desc_title">Обсудите задачу со специалистом!</div>
          <div className="home_phone_recall_clientInfo" style={{ marginTop: "0px" }}>
            <div className="home_phone_recall_clientInfo_inputs">
              <input placeholder="Как к Вам обращаться?" />
              <Cleave
                type="tel"
                placeholder="Телефон для связи"
                options={{
                  numericOnly: true,
                  delimiters: ["", ") ", " - ", " - "],
                  blocks: [3, 3, 3, 2, 2],
                  prefix: "+7(",
                  noImmediatePrefix: true,
                }}
              />
            </div>
            <div className="home_phone_recall_clientInfo_buttons">
              <div className="home_phone_recall_clientInfo_button">Отправить</div>
              <div className="home_phone_recall_clientInfo_agrees">
                Нажимая на кнопку, вы даете согласие на обработку персональных данных, разрешенных для передачи
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="services_elem">
        <div className="services_elem_desc">
          <span className="services_elem_desc_title">Проверка истории автомобиля</span>
          <div className="services_elem_desc_par">
            <span>- Проверка по базам ГИБДД, реестру залогов</span>
            <span>- Проверка зарубежных отчетов (CarFax, AutoCheck)</span>
            <span>- Проверка юридической частоты</span>
          </div>
          <span className="services_elem_desc_price">От 2 000 ₽</span>
        </div>

        <div className="services_elem_img">
          <img src={ServiceCheck} />
        </div>

        <div className="services_elem_recall">
          <div className="services_elem_desc_title">Сделайте первый шаг к безопасной покупке!</div>
          <div className="home_phone_recall_clientInfo" style={{ marginTop: "0px" }}>
            <div className="home_phone_recall_clientInfo_inputs">
              <input placeholder="Как к Вам обращаться?" />
              <Cleave
                type="tel"
                placeholder="Телефон для связи"
                options={{
                  numericOnly: true,
                  delimiters: ["", ") ", " - ", " - "],
                  blocks: [3, 3, 3, 2, 2],
                  prefix: "+7(",
                  noImmediatePrefix: true,
                }}
              />
            </div>
            <div className="home_phone_recall_clientInfo_buttons">
              <div className="home_phone_recall_clientInfo_button">Отправить</div>
              <div className="home_phone_recall_clientInfo_agrees">
                Нажимая на кнопку, вы даете согласие на обработку персональных данных, разрешенных для передачи
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="services_elem">
        <div className="services_elem_desc">
          <span className="services_elem_desc_title">Выкуп Вашего автомобиля</span>
          <div className="services_elem_desc_par">
            <span>- Предварительная оценка по фото и описанию</span>
            <span>- Выезд специалиста или осмотр на нашей площадке</span>
            <span>- Проверка технического состояния и юридической чистоты</span>
            <span>- Прозрачное определение стоимости</span>
          </div>
          <span className="services_elem_desc_price">Обсудим ваш запрос</span>
        </div>

        <div className="services_elem_img">
          <img src={ServiceBuy} />
        </div>

        <div className="services_elem_recall">
          <div className="services_elem_desc_title">Получите персональное предложение!</div>
          <div className="home_phone_recall_clientInfo" style={{ marginTop: "0px" }}>
            <div className="home_phone_recall_clientInfo_inputs">
              <input placeholder="Как к Вам обращаться?" />
              <Cleave
                type="tel"
                placeholder="Телефон для связи"
                options={{
                  numericOnly: true,
                  delimiters: ["", ") ", " - ", " - "],
                  blocks: [3, 3, 3, 2, 2],
                  prefix: "+7(",
                  noImmediatePrefix: true,
                }}
              />
            </div>
            <div className="home_phone_recall_clientInfo_buttons">
              <div className="home_phone_recall_clientInfo_button">Отправить</div>
              <div className="home_phone_recall_clientInfo_agrees">
                Нажимая на кнопку, вы даете согласие на обработку персональных данных, разрешенных для передачи
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="services_elem">
        <div className="services_elem_desc">
          <span className="services_elem_desc_title">Сопровождение сделки</span>
          <div className="services_elem_desc_par">
            <span>- Подготовка документов купли-продажи</span>
            <span>- Проверка всех документов</span>
            <span>- Сопровождение при передачи денежных средств</span>
          </div>
          <span className="services_elem_desc_price">От 3 000 ₽</span>
        </div>

        <div className="services_elem_img">
          <img src={ServiceControl} />
        </div>

        <div className="services_elem_recall">
          <div className="services_elem_desc_title">Оставьте заявку на предоставление услуги!</div>
          <div className="home_phone_recall_clientInfo" style={{ marginTop: "0px" }}>
            <div className="home_phone_recall_clientInfo_inputs">
              <input placeholder="Как к Вам обращаться?" />
              <Cleave
                type="tel"
                placeholder="Телефон для связи"
                options={{
                  numericOnly: true,
                  delimiters: ["", ") ", " - ", " - "],
                  blocks: [3, 3, 3, 2, 2],
                  prefix: "+7(",
                  noImmediatePrefix: true,
                }}
              />
            </div>
            <div className="home_phone_recall_clientInfo_buttons">
              <div className="home_phone_recall_clientInfo_button">Отправить</div>
              <div className="home_phone_recall_clientInfo_agrees">
                Нажимая на кнопку, вы даете согласие на обработку персональных данных, разрешенных для передачи
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;

export const ServicesTop = () => {
  const [time, setTime] = useState(0);
  const texts = [
    {
      title1: "Все услуги для безопасной покупки и продажи автомобиля",
      title2: "Ваш автомобиль - наш профессиональный контроль",
    },
    {
      title1: "От поиска автомобиля до безопасного оформления сделки",
      title2: "Выбирайте автомобиль уверенно — остальное мы берём на себя",
    },
    {
      title1: "Помогаем выбрать, проверить и выгодно купить автомобиль",
      title2: "Наши эксперты - надёжные помощники на всех этапах поиска и проверки автомобиля",
    },
  ];

  useEffect(() => {
    setTimeout(() => setTime((prev) => (prev == 2 ? (prev = 0) : prev + 1)), 7000);
  }, [time]);

  return (
    <div className="content_header">
      <div className="home_top_area">
        <span className="home_top_area_title_1">{texts[time]["title1"]}</span>
        <div className="home_top_area_title_2">
          <span>{texts[time]["title2"]}</span>
        </div>
      </div>
    </div>
  );
};
